module.exports = __webpack_public_path__ + "static/media/news-img2.fc8fb53b.png";